import { render, staticRenderFns } from "./BaseNewButton.vue?vue&type=template&id=0125af5b&scoped=true"
import script from "./BaseNewButton.vue?vue&type=script&lang=js"
export * from "./BaseNewButton.vue?vue&type=script&lang=js"
import style0 from "./BaseNewButton.vue?vue&type=style&index=0&id=0125af5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0125af5b",
  null
  
)

export default component.exports